module.exports = __webpack_public_path__ + "static/media/draft.92a5b21e.svg";